<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator"
             v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1 || hasClaims(info.User.DynamicRole, claimEnums.faqEdit))">
            <div class="control-block-left">
                 <project-select :user="info.User" @onChange="onProjectChange"
                                 v-if="(info.User.MainRole === 'administrators' || info.ProjectsLength > 1)"></project-select>
            </div>
            <div class="control-block-right">
                <button class="btn edit" @click.stop="add()" v-if="(info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.faqEdit))">Добавить</button>
            </div>
        </div>
        
        <div class="body-panel-content body-panel-content-page">
            <Container @drop="onFieldSettingsDrop" :lock-axis="lockAxis" drag-handle-selector=".svg-icon">
                <Draggable v-for="(item, i) of editItemsOrdered">
                    <div>
                        <template v-if="!item.editing">
                            <div :class="['lite-block block-in-page-collapce', {'expanded': item.expanded}]">
                                <div class="flex padding-right-20" @click="onItemSelect(item)">
                                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use :xlink:href="'/Content/dist/faq_svg.svg#' + item.svgName"></use>
                                    </svg>
                                    <p class="header" v-html="formatMarkdownLiteToHtml(item.title)"></p>
                                </div>

                                <div class="lite-block-detail">
                                    <p v-html="formatMarkdownLiteToHtml(item.body)"></p>
                                    <button type="button" class="btn edit btn-img" @click="deleteItem(item, i)" v-if="!item.editing && item.expanded && info.User && (info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.faqEdit))">
                                        <img src="../../img/icon-del.png" alt="" />
                                    </button>
                                    <button class="btn edit btn-img" @click.stop="onItemEdit(item, i)" v-if="!item.editing && item.expanded && info.User && (info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.faqEdit))">
                                        <img src="../../img/pencil-edit-button.png" alt="" />
                                    </button>
                                </div>
                            </div>
                        </template>
                        <template v-if="item.editing">
                            <div class="block-in-page lite-block">
                                <div class="flex padding-right-20">
                                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use :xlink:href="'/Content/dist/faq_svg.svg#' + item.svgName"></use>
                                    </svg>
                                    <p class="header" v-html="formatMarkdownLiteToHtml(item.title)"></p>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Заголовок вопроса
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <input type="text"
                                           :name="'Title' + i"
                                           :class="['input-text', {'input-error': errors.has('Title' + i)}]"
                                           v-validate="'required'"
                                           v-model="item.title"
                                           data-vv-as="Заголовок" />
                                    <span class="field-validation-valid">{{ errors.first('Title' + i) }}</span>
                                </div>
                                <div class="form-group">
                                    <label class="input-text-lbl">
                                        Текст ответа
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <textarea style="height:100px" rows="10"
                                              :name="'Body' + i"
                                              :class="['input-memo', {'input-error': errors.has('Body' + i)}]"
                                              v-validate="'required'"
                                              v-model="item.body"
                                              data-vv-as="Текст ответа">
                            </textarea>
                                    <span class="field-validation-valid">{{ errors.first('Body' + i) }}</span>
                                </div>
                                <div class="form-group">
                                    <label class="input-text-lbl">
                                        Иконка
                                    </label>
                                    <div class="svg-container margin-top-5">
                                        <svg v-for="icon of icons" @click="onIconSelect(i, icon)" :class="['svg-icon', {selected: icon === item.svgName}]" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use :xlink:href="'/Content/dist/faq_svg.svg#' + icon"></use>
                                        </svg>
                                    </div>
                                </div>

                                <div class="btns flex margin-top-10">
                                    <button type="button" class="btn btn-primary" @click="save(item)">Сохранить</button>
                                    <button type="button" class="btn btn-default" @click="itemCancelEditing()">Отмена</button>
                                </div>
                            </div>
                        </template>
                    </div>
                </Draggable>
            </Container>
        </div>

    </div>

</template>

<script>
import UI from '../helpers/ui-helpers'
import BackendApi from '../backendApi'
import projectMixin from '../helpers/project-mixin'
    import '../../img/faq_svg.svg'
    import { Container, Draggable } from 'vue-smooth-dnd'

let backendApi = new BackendApi();

export default {
    name: "faq-component",

    props: ['name', 'value', 'info'],

        mixins: [projectMixin],

        components: { Container, Draggable },

        data() {
            return {
                origin: [],
                editItems: [],
                icons: ['Calendar', 'Chat', 'CreditCard', 'Edit', 'Eye', 'File2', 'Flag', 'Folder1', 'IdCard', 'Idea', 'Image', 'Inbox', 'Key', 'Money', 'PhoneCall', 'Reload', 'Settings', 'Trophy', 'User']
            }
        },

        computed: {
            editItemsOrdered: function () {
                return _.orderBy(this.editItems, 'itemOrder');
            },

            editItemsStr() {
                if (this.editItems) {
                    let temp = JSON.parse(JSON.stringify(_.orderBy(this.editItems, 'itemOrder')));
                    for (let s of temp) {
                        delete s.editing;
                        delete s.expanded;
                    }
                    return JSON.stringify(temp);
                }
                else return null;
            },

            lockAxis() {
                return (this.info.User.MainRole === 'administrators' || this.hasClaims(this.info.User.DynamicRole, this.claimEnums.faqEdit)) ? 'y' : '1';
            }
        },

    watch: {
        value(newVal) {
            //console.info('watch -> value');
            this.assignItems(newVal);
        }
    },

    methods: {
        onIconSelect(i, icon){
            this.editItems[i].svgName = this.editItems[i].svgName === icon ? null : icon;
            this.$set(this.editItems, i, this.editItems[i]);
        },

        onItemSelect(item) {
            let flag = !item.expanded;
            for (let i of this.editItems) {
                i.expanded = false;
            }
            item.expanded = flag;
        },

        onItemEdit(item, i){
            this.itemCancelEditing();

            this.editItems[i].editing = true;
        },

        itemCancelEditing(){
            this.editItems = [];
            for (let i of this.origin) {
                this.editItems.push(Object.assign({}, i));
            }
        },

        deleteItem(item, i){
            if (confirm('Удалить этот вопрос?')) {
                this.editItems.splice(i, 1);
                this.save(item);
            }
        },

        save(item){
            let vm = this;
            this.$validator.validate().then(result => {
                if (!result) {
                    UI.toastr.error('Проверьте введённые данные');
                }
                else {
                    item.editing = false;
                    item.expanded = false;

                    let faqJson = vm.editItemsStr;
                    //console.info('faqJson', faqJson)

                    //let selectedProjectId = localStorage.getItem('selectedProjectId');
                    vm.callApiWrapper(backendApi.projectInfoSave({
                        projectId: vm.projectId,
                        faq: faqJson
                    })).then(function (resp) {
                        if (resp.hasError) {
                            UI.toastr.error('Ошибка при сохранении');
                        }
                        else{
                            vm.origin = [];
                            for (let i of vm.editItems) {
                                vm.origin.push(Object.assign({}, i));
                            }

                            vm.$emit('input', faqJson);
                            UI.toastr.success('Успешно сохранено');
                        }
                    });
                }
            });

        },

        add(){
            this.itemCancelEditing();

            let newOrder = 1;
            this.editItems.forEach(x => {
                if (x.itemOrder != undefined && x.itemOrder > newOrder) {
                    newOrder = x.itemOrder + 1;
                }
            });
            let item = { title: 'Новый вопрос', body: '', expanded: false, editing: true, svgName: null, itemOrder: newOrder };
            this.editItems.push(item);
            this.origin.push(Object.assign({}, item));
        },

        onProjectChange(item){
            this.projectId = item.Id;
            this.$emit('projectChange');
        },

        assignItems(data){
            let vm = this;

            if(data) {
                let items = JSON.parse(data);
                vm.editItems = [];
                let order = 1;
                for (let i of items) {
                    i.expanded = false;
                    i.editing = false;
                    i.itemOrder = order++;
                    vm.editItems.push(Object.assign({}, i));
                }
                vm.origin = items;
            }else{
                vm.editItems = [];
                vm.origin = [];
            }
        },

        onFieldSettingsDrop(dropResult) {
            let vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            let temp = _.orderBy(vm.editItems, 'itemOrder');
            let itemToAdd;
            if (dropResult.removedIndex != null) {
                itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                temp.splice(dropResult.addedIndex, 0, itemToAdd)
            }

            let order = 1;
            temp.forEach((x) => {
                x.itemOrder = order++;
            });

            vm.editItems = temp;
            vm.save(itemToAdd);
        },
    },

    mounted() {
        let vm = this;

        vm.assignItems(vm.value);
    }
}
</script>


// WEBPACK FOOTER //
// Content/src/components/FaqComponent.vue